import { render, staticRenderFns } from "./FAQHeader.vue?vue&type=template&id=55e6119e&scoped=true&"
import script from "./FAQHeader.vue?vue&type=script&lang=ts&"
export * from "./FAQHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FAQHeader.vue?vue&type=style&index=0&id=55e6119e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6119e",
  null
  
)

export default component.exports
import QHeader from 'quasar/src/components/header/QHeader.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QHeader,QIcon,QSpace,QBtn});
